export default "__VITE_ASSET__Bja$e6CI__"